import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer, staggerItem, cardHover } from '../../utility/framerMotionAnimations';
import './EmiCalculator.css';

const EmiCardsSection = () => {
    return (
        <div className="emi-cards-section">
            <motion.div 
                className="emi-cards-container"
                variants={staggerContainer}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
            >
                {/* Card 1: How EMI is Calculated */}
                <motion.div 
                    className="emi-card"
                    variants={staggerItem}
                    whileHover={cardHover.hover}
                >
                    <div className="card-icon">
                        <img 
                            src="/images/calculator.png" 
                            alt="Calculator Icon"
                            className="custom-icon"
                        />
                    </div>
                    <h3 className="card-title">
                        How EMI is Calculated
                    </h3>
                    <div className="card-content">
                        <div className="formula-box">
                            <p className="formula-text">
                                E = P × r × (1 + r)<sup>n</sup> / ((1 + r)<sup>n</sup> - 1)
                            </p>
                            <div className="formula-explanation">
                                <p><strong>Where:</strong></p>
                                <ul>
                                    <li>E = EMI amount</li>
                                    <li>P = Principal loan amount</li>
                                    <li>r = Monthly interest rate</li>
                                    <li>n = Total number of months</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </motion.div>

                {/* Card 2: Why Choose Us? */}
                <motion.div 
                    className="emi-card"
                    variants={staggerItem}
                    whileHover={cardHover.hover}
                >
                    <div className="card-icon">
                        <img 
                            src="/images/building.png" 
                            alt="Building Icon"
                            className="custom-icon"
                        />
                    </div>
                    <h3 className="card-title">
                        Why Choose Us?
                    </h3>
                    <ul className="card-list">
                        <li>Competitive interest rates</li>
                        <li>Quick loan approval</li>
                        <li>Flexible repayment options</li>
                    </ul>
                </motion.div>

                {/* Card 3: Tips for Lower EMI */}
                <motion.div 
                    className="emi-card"
                    variants={staggerItem}
                    whileHover={cardHover.hover}
                >
                    <div className="card-icon">
                        <img 
                            src="/images/ai-innovation.png" 
                            alt="Lightbulb Icon"
                            className="custom-icon"
                        />
                    </div>
                    <h3 className="card-title">
                        Tips for Lower EMI
                    </h3>
                    <ul className="card-list">
                        <li>Choose longer tenure</li>
                        <li>Make lump sum payments</li>
                        <li>Opt for fixed rate loans</li>
                    </ul>
                </motion.div>

                {/* Card 4: Frequently Asked Questions */}
                <motion.div 
                    className="emi-card"
                    variants={staggerItem}
                    whileHover={cardHover.hover}
                >
                    <div className="card-icon">
                        <img 
                            src="/images/help-circle.png" 
                            alt="Question Icon"
                            className="custom-icon"
                        />
                    </div>
                    <h3 className="card-title">
                        Frequently Asked Questions
                    </h3>
                    <div className="faq-content">
                        <div className="faq-item">
                            <h4 className="faq-question">What is EMI?</h4>
                            <p className="faq-answer">EMI stands for Equated Monthly Installment.</p>
                        </div>
                        <div className="faq-item">
                            <h4 className="faq-question">How is interest calculated?</h4>
                            <p className="faq-answer">Interest is calculated on the outstanding principal.</p>
                        </div>
                    </div>
                </motion.div>
            </motion.div>
        </div>
    );
};

export default EmiCardsSection;

